import _ from 'underscore'
import Backbone from 'backbone'
import StudentViewTemplate from '../templates/student.tpl'
import Request from '../helpers/request'
import PageModel from '../models/page'
import PageOptionView from './page-option'
import ClassReportingView from './class-reporting'
import ClassView from './class'
import ClassModel from '../models/class'

const StudentView = Backbone.View.extend({
    tagName: 'div',
    id: 'student-view',
    events: {
        'change .limits': 'changeLimit',
        'change .pages': 'changePage',
    },
    limit: 15,
    page: 1,
    reporting: false,
    initialize() {
        this.template = _.template(StudentViewTemplate)
    },
    render() {
        this.$el.html(this.template({
            limits: [15, 25, 50],
            limit: this.limit,
        }))

        Request({
            url: '/api/school/class',
            method: 'GET',
            data: {
                limit: this.limit,
                page: this.page,
                sort: 'nameLowercase',
            },
        })
            .then((response) => this.listStudents(response))

        return this
    },
    listStudents(response) {
        /*
        'total': 9,
        'limit': 15,
        'page': 1,
        'pages': 1
        */

        // This works out how many page links to show
        // IF the calculation returns 0 it will show 1
        const pages = Math.ceil(response.total / this.limit) || 1

        for (let index = 1; index <= pages; index++) {
            const pageModel = new PageModel({
                number: index,
                selected: this.page == index,
            })
            const pageOptionView = new PageOptionView({model: pageModel})
            this.$('.pages').append(pageOptionView.render().el)
        }

        // class list
        _.each(response.docs, (classItem) => {
            const classModel = new ClassModel({
                id: classItem._id,
                name: classItem.name,
            })
            let classView = null

            if (this.reporting) {
                classView = new ClassReportingView({model: classModel})
            } else {
                classView = new ClassView({model: classModel})
            }

            this.$('.user-list').append(classView.render().el)
        })
    },
    changeLimit(event) {
        this.limit = event.target.value
        this.page = 1
        this.render()
    },
    changePage(event) {
        this.page = event.target.value
        this.render()
    }
})

export default StudentView